import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import msg from "./msg/msg_zh";
import productModel from "./product/index_zh";
import userModel from "./user/index_zh";
import orderModel from "./order/index_zh";
import routerModel from "./router/index_zh";
import storeModel from "./store/index_zh";
const zh = {
    //全局配置
    search: "查询结果",
    reset: "重置",
    exportData: "导出数据",
    add: "添加",
    edit: "编辑",
    view: "查看",
    remove: "删除",
    batch_remove: "批量删除",
    batch_error: "请选择需要删除的行",
    table_operatorLabel: "操作",
    back: "返回",
    search_btn1: "查询结果",
    search_btn2: "重置",
    form_cancle: "取消",
    form_submit: "提交",
    dialog_cancle: "取消",
    dialog_comfirm: "确定",
    dialog_submit: "提交",
    option_all: "全部",

    // 提示
    msg: msg,
    // 商品模块
    ...productModel,
    // 用户模块
    ...userModel,
    // 订单模块
    ...orderModel,
    // 门店模块
    ...storeModel,

    // 路由
    ...routerModel,

    //局部
    status: {
        disabled: "不可用", //不可用
        abled: "可用" //可用
    },
    //elementUI
    ...zhLocale
};
export default zh;
